import _extends from "@babel/runtime/helpers/esm/extends";
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { grey } from '../colors';

/**
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html)
 */

/**
 * MuiInputLabel
 */
export const MuiInputLabel = {
  styleOverrides: {
    formControl: ({
      theme
    }) => _extends({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      height: 24,
      marginBottom: theme.spacing(0.5),
      '&.Mui-focused, &.Mui-error': {
        color: theme.palette.text.primary
      },
      '&.Mui-disabled': {
        color: theme.palette.grey[500]
      }
    })
  }
};

/**
 * MuiOutlinedInput
 */
export const MuiOutlinedInput = {
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => ({
      borderRadius: 4,
      background: theme.palette.common.white,
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: grey[300]
      },
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: grey[300]
      },
      [`&.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: grey[300]
      },
      [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
        border: `1px solid ${theme.palette.secondary.main}`
      },
      '&.Mui-readOnly': _extends({
        background: 'transparent'
      }, ownerState.startAdornment && {
        background: theme.palette.common.white
      }),
      '&.Mui-disabled:not(.Mui-readOnly)': {
        background: theme.palette.grey[100]
      },
      // TODO danielmana move to the base theme options
      '& legend': {
        width: 0
      }
    })
  }
};
export const MuiInputBase = {
  styleOverrides: {
    input: ({
      theme
    }) => ({
      '&::placeholder': {
        color: theme.palette.text.disabled,
        opacity: 1
      },
      '&.Mui-disabled::placeholder': {
        color: theme.palette.grey[500]
      }
    }),
    multiline: ({
      theme
    }) => ({
      '&.MuiOutlinedInput-root': {
        padding: theme.spacing(0, 0.25, 0.25, 0)
      },
      '& .MuiInputBase-inputMultiline': {
        '&:not(.MuiInputBase-inputSizeSmall)': {
          padding: theme.spacing(1.25, 2.875, 1.5, 1.5)
        },
        resize: 'vertical',
        '&::-webkit-resizer': {
          background: `transparent url("data:image/svg+xml,%3Csvg class='bh-svg-grabber' width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false'%3E%3Ctitle%3EGrabber%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg fill='%2356595D'%3E%3Cg transform='translate(5.359087, 5.359087) rotate(-45.000000) translate(-5.359087, -5.359087) translate(1.359087, 3.859087)'%3E%3Cpath d='M5.5,2 C5.77614237,2 6,2.22385763 6,2.5 C6,2.77614237 5.77614237,3 5.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.22385763 2.22385763,2 2.5,2 L5.5,2 Z M7.5,1.13686838e-13 C7.77614237,1.13636111e-13 8,0.223857625 8,0.5 C8,0.776142375 7.77614237,1 7.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 C-3.38176876e-17,0.223857625 0.223857625,1.13737564e-13 0.5,1.13686838e-13 L7.5,1.13686838e-13 Z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E") no-repeat bottom right`
        }
      }
    })
  }
};
export const MuiFormHelperText = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      marginLeft: 0,
      color: theme.palette.text.primary,
      '&.Mui-disabled': {
        color: theme.palette.grey[500]
      }
    })
  }
};